import type { LocalDatabase, PersistenceHealth } from '../../application/ports/LocalDatabase';
import { DatabaseUnavailableError } from '../../application/errors/PersistenceError';
import { DATABASE_SCHEMA_VERSION } from './databaseConfig';
import type { AscendInvictusDatabase } from './AscendInvictusDatabase';
import { executePersistence } from './translatePersistenceError';

export class DexieLocalDatabase implements LocalDatabase {
  public constructor(private readonly database: AscendInvictusDatabase) {}

  public open(): Promise<void> {
    if (typeof globalThis.indexedDB === 'undefined') {
      return Promise.reject(new DatabaseUnavailableError());
    }

    return executePersistence('open', async () => {
      await this.database.open();
    });
  }

  public close(): void {
    this.database.close();
  }

  public async healthCheck(): Promise<PersistenceHealth> {
    const indexedDbSupported = typeof globalThis.indexedDB !== 'undefined';
    if (!indexedDbSupported) {
      return {
        storageSupported: false,
        adapterLoaded: true,
        schemaVersion: DATABASE_SCHEMA_VERSION,
        healthy: false,
      };
    }

    return executePersistence('read', async () => {
      await this.database.open();
      await this.database.profiles.count();
      return {
        storageSupported: true,
        adapterLoaded: true,
        schemaVersion: DATABASE_SCHEMA_VERSION,
        healthy: true,
      };
    });
  }
}
